import React, { memo } from 'react';
import { BillingPageStatistics } from '../../../../hooks/useBillingStatistics';
import {
  BuildingIcon,
  CheckCircleIcon,
  WarningIcon,
  TrendingUpIcon
} from '../../../common/Icons';

interface StatisticCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  bgColor: string;
  textColor: string;
  iconBgColor: string;
}

const StatisticCard = memo<StatisticCardProps>(({
  title,
  value,
  icon,
  bgColor,
  textColor,
  iconBgColor
}) => (
  <div className={`${bgColor} p-6 rounded-lg shadow-sm border border-gray-200`}>
    <div className="flex items-center">
      <div className={`p-2 ${iconBgColor} rounded-md`}>
        {icon}
      </div>
      <div className="ml-4">
        <p className="text-sm text-gray-600">{title}</p>
        <p className={`text-2xl font-bold ${textColor}`}>{value}</p>
      </div>
    </div>
  </div>
));

interface BillingStatisticsCardsProps {
  statistics: BillingPageStatistics;
}

const BillingStatisticsCards = memo<BillingStatisticsCardsProps>(({ statistics }) => {
  const cardConfigs = [
    {
      title: '전체 호실',
      value: statistics.totalRooms,
      icon: <BuildingIcon className="w-6 h-6 text-blue-600" />,
      bgColor: 'bg-white',
      textColor: 'text-gray-900',
      iconBgColor: 'bg-blue-100'
    },
    {
      title: '설정 완료',
      value: statistics.completedSettings,
      icon: <CheckCircleIcon className="w-6 h-6 text-green-600" />,
      bgColor: 'bg-white',
      textColor: 'text-gray-900',
      iconBgColor: 'bg-green-100'
    },
    {
      title: '설정 필요',
      value: statistics.neededSettings,
      icon: <WarningIcon className="w-6 h-6 text-yellow-600" />,
      bgColor: 'bg-white',
      textColor: 'text-gray-900',
      iconBgColor: 'bg-yellow-100'
    },
    {
      title: '설정률',
      value: `${statistics.completionRate}%`,
      icon: <TrendingUpIcon className="w-6 h-6 text-purple-600" />,
      bgColor: 'bg-white',
      textColor: 'text-gray-900',
      iconBgColor: 'bg-purple-100'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      {cardConfigs.map((config, index) => (
        <StatisticCard
          key={`${config.title}-${index}`}
          {...config}
        />
      ))}
    </div>
  );
});

StatisticCard.displayName = 'StatisticCard';
BillingStatisticsCards.displayName = 'BillingStatisticsCards';

export default BillingStatisticsCards;